export default __webpack_public_path__ + "static/media/thanks.dfb040fa.png";